export default __webpack_public_path__ + "static/media/HeroImage.bcda47d4.webp";